<template>
    <div class="row">
        <div class="col-md-12">
            <ul
                class="nav nav-tabs custom-nav-tabs templates-filter-page"
                id="templates-tab"
                role="tablist"
                style="justify-content: start"
            >
                <li class="nav-item" role="presentation">
                    <button
                        class="nav-link active cursor-default"
                        id="templates-list"
                        data-toggle="tab"
                        data-target="#templates-list"
                        type="button"
                        role="tab"
                        aria-controls="templates-list"
                        aria-selected="true"
                    >
                        Templates
                    </button>
                </li>
            </ul>
            <div
                class="tab-content"
                id="myTabContent"
                style="padding-top: 20px"
            >
                <div
                    class="tab-pane fade show active"
                    id="templates-list"
                    role="tabpanel"
                    aria-labelledby="templates-list"
                >
                    <div class="container">
                        <div class="row mt-1 mb-3">
                            <div
                                class="col-md-3 d-none d-md-block d-lg-block"
                                style="padding-left: 0 !important"
                            >
                                <button
                                    class="btn btn-secondary"
                                    @click.prevent="toggleSidebar"
                                    style="
                                        background: #fff !important;
                                        border: 1px solid #e1e1e1 !important;
                                        color: rgb(24, 88, 122);
                                        padding: 8px 30px;
                                    "
                                >
                                    <i class="fa fa-sliders"></i>&nbsp; Filters
                                    <template v-if="showSidebar">
                                        <i class="fa fa-angle-left ml-4"></i>
                                    </template>
                                    <template v-else>
                                        <i class="fa fa-angle-right ml-4"></i>
                                    </template>
                                </button>
                            </div>
                            <div
                                class="col-md-9"
                                style="padding-top: 5px !important"
                            >
                                <div class="row d-flex justify-content-between">
                                    <div class="col art-pt-10">
                                        <!-- <small
                                                style="color: #18587a"
                                                v-if="meta"
                                            >
                                                Showing
                                                {{
                                                    meta.from && meta.to
                                                        ? `${meta.from}-${meta.to}`
                                                        : "0"
                                                }}
                                                of {{ meta.total || 0 }} results
                                            </small> -->
                                        <a-input-search
                                            v-model="search"
                                            placeholder="Search Templates"
                                            style="width: 250px"
                                            @search="fetchTemplates"
                                            class="ant-template-search-input"
                                        />
                                    </div>
                                    <div class="col text-md-right">
                                        <span class="text-muted">Sort by:</span>
                                        &nbsp;
                                        <select
                                            name="orderBy"
                                            class="sort-order-dropdown"
                                            v-model="orderBy"
                                            @change="fetchTemplates"
                                        >
                                            <option value="latest">
                                                Recent
                                            </option>
                                            <option value="popularity">
                                                Popular
                                            </option>
                                            <option value="trending">
                                                Featured
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div
                                class="col-md-3"
                                style="padding-left: 0; padding-right: 20px"
                                v-if="showSidebar"
                            >
                                <a-collapse
                                    v-model="activeKey"
                                    ghost
                                    expandIconPosition="right"
                                    class="templates-filter-option"
                                    v-if="!filterOptionsLoading"
                                >
                                    <a-collapse-panel
                                        key="1"
                                        header="Categories"
                                    >
                                        <div class="art-mb-8">
                                            <a-checkbox
                                                v-model="checkAllCategories"
                                                @change="
                                                    onCheckAllCategoriesChange
                                                "
                                                style="margin-bottom: 8px"
                                            >
                                                All Categories
                                            </a-checkbox>
                                        </div>
                                        <a-checkbox-group
                                            v-model="selectedCategories"
                                            :options="categoriesList"
                                            @change="fetchTemplates"
                                        />
                                    </a-collapse-panel>
                                    <a-collapse-panel key="2" header="Colors">
                                        <div v-if="colors.length">
                                            <a-tooltip
                                                v-for="color in colors"
                                                :key="color.code"
                                                :title="color.title"
                                                placement="top"
                                            >
                                                <a-badge
                                                    :color="color.code"
                                                    @click="
                                                        onChangeColor(color)
                                                    "
                                                    :class="{
                                                        'ant-badge-status-dot-active':
                                                            selectedColors.includes(
                                                                color.slug
                                                            ),
                                                    }"
                                                    :title="color.title"
                                                />
                                            </a-tooltip>
                                        </div>
                                    </a-collapse-panel>
                                    <a-collapse-panel key="3" header="Styles">
                                        <a-checkbox-group
                                            v-model="selectedStyles"
                                            :options="stylesList"
                                            @change="fetchTemplates"
                                        />
                                    </a-collapse-panel>
                                    <a-collapse-panel
                                        key="4"
                                        header="Aspect Ratio"
                                    >
                                        <a-checkbox-group
                                            v-model="selectedAspectRatios"
                                            :options="aspectRatiosList"
                                            @change="fetchTemplates"
                                        />
                                    </a-collapse-panel>
                                    <a-collapse-panel key="5" header="License">
                                        <a-checkbox-group
                                            v-model="selectedLicenses"
                                            :options="licenses"
                                            @change="fetchTemplates"
                                        />
                                    </a-collapse-panel>
                                </a-collapse>
                                <div
                                    v-else
                                    style="
                                        width: 100%;
                                        min-height: 50vh;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                    "
                                >
                                    <a-skeleton
                                        loading
                                        :paragraph="{ rows: 4 }"
                                    />
                                </div>
                            </div>
                            <div
                                :class="{
                                    'col-md-9': showSidebar,
                                    'col-md-12': !showSidebar,
                                }"
                                style="padding-left: 0; padding-right: 0"
                            >
                                <div
                                    class="container"
                                    style="padding-left: 0; padding-right: 0"
                                >
                                    <div
                                        class="row"
                                        style="
                                            padding-left: 0px !important;
                                            margin-left: 0;
                                        "
                                    >
                                        <template
                                            v-if="
                                                !searching &&
                                                templates.length > 0
                                            "
                                        >
                                            <template-thumb
                                                v-for="template in templates"
                                                :key="template.id"
                                                :template="template"
                                                :showSidebar="showSidebar"
                                            />
                                        </template>
                                        <template v-else-if="searching">
                                            <a-skeleton
                                                active
                                                :paragraph="{ rows: 4 }"
                                                style="
                                                    margin-left: 15px;
                                                    margin-right: 15px;
                                                "
                                            />
                                        </template>
                                        <template v-else>
                                            <h4 class="text-center ml-4 mt-5">
                                                No template found in this
                                                criteria.
                                            </h4>
                                        </template>
                                    </div>
                                    <pagination
                                        v-if="meta.last_page > 1"
                                        :total="meta.total"
                                        :current="meta.current_page"
                                        :perPage="24"
                                        @pageChanged="handleOnPageChange"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HTTP } from "../api";
import { buildAdminTemplateListQueryString } from "../components/templates/helpers";
import TemplateThumb from "./template-thumb";
import Pagination from "./pagination";
export default {
    props: ["data"],
    components: {
        TemplateThumb,
        Pagination,
    },
    data() {
        return {
            activeKey: ["1", "2", "3", "4", "5"],
            filterOptionsLoading: false,
            searching: true,
            categories: [],
            aspectRatios: [],
            colors: [],
            styles: [],
            licenses: [
                {
                    label: "All",
                    value: "all",
                },
                {
                    label: "Free",
                    value: "free",
                },
                {
                    label: "Premium",
                    value: "premium",
                },
            ],
            checkAllCategories: false,
            selectedCategories: [],
            selectedStyles: [],
            selectedColors: [],
            selectedAspectRatios: [],
            selectedLicenses: [],
            meta: {},
            orderBy: "latest",
            templates: [],
            showSidebar: true,
            search: "",
        };
    },
    computed: {
        categoriesList() {
            return this.categories.map((cat) => ({
                label: cat.title,
                value: cat.slug,
            }));
        },
        stylesList() {
            return this.styles.map((cat) => ({
                label: cat.title,
                value: cat.slug,
            }));
        },
        aspectRatiosList() {
            return this.aspectRatios.map((cat) => ({
                label: cat.title,
                value: cat.slug,
            }));
        },
    },
    watch: {
        selectedCategories(newVal, oldVal) {
            if (newVal.length < this.categories.length) {
                this.checkAllCategories = false;
            }
            if (newVal.length === this.categories.length) {
                this.checkAllCategories = true;
            }
        },
    },
    methods: {
        toggleSidebar() {
            this.showSidebar = !this.showSidebar;
        },
        async fetchFilterOptions() {
            this.filterOptionsLoading = true;
            try {
                const { data } = await HTTP.get("template-related-models");
                this.categories = data?.categories;
                this.aspectRatios = data?.aspectRatios;
                this.styles = data?.styles;
                this.colors = data?.colors;
            } catch (error) {}
            this.filterOptionsLoading = false;
        },
        onCheckAllCategoriesChange(e) {
            const checked = e.target.checked;
            if (checked) {
                this.selectedCategories = this.categories.map(
                    (cat) => cat.slug
                );
            } else {
                this.selectedCategories = [];
            }
            this.fetchTemplates();
        },
        async fetchTemplates() {
            const queryString = this.buildPayload();
            this.searching = true;
            const { data } = await HTTP.get(`/templates${queryString}`);
            this.templates = data?.data;
            this.meta = data?.meta;
            this.searching = false;
        },
        onChangeColor(color) {
            if (this.selectedColors.includes(color.slug)) {
                this.selectedColors = this.selectedColors.filter(
                    (c) => c !== color.slug
                );
            } else {
                this.selectedColors = [...this.selectedColors, color.slug];
            }
            this.fetchTemplates();
        },
        buildPayload() {
            const query = {};
            if (
                this.selectedCategories &&
                this.selectedCategories.length > 0 &&
                this.selectedCategories.length < this.categories.length
            ) {
                query.categories = this.categories
                    .filter((cat) => this.selectedCategories.includes(cat.slug))
                    .map((cat) => cat.id);
            }
            if (this.selectedColors && this.selectedColors.length > 0) {
                query.colors = this.colors
                    .filter((col) => this.selectedColors.includes(col.slug))
                    .map((col) => col.id);
            }
            if (this.selectedStyles && this.selectedStyles.length > 0) {
                query.styles = this.styles
                    .filter((style) => this.selectedStyles.includes(style.slug))
                    .map((style) => style.id);
            }
            if (
                this.selectedAspectRatios &&
                this.selectedAspectRatios.length > 0
            ) {
                query.aspectRatios = this.aspectRatios
                    .filter((ratio) =>
                        this.selectedAspectRatios.includes(ratio.slug)
                    )
                    .map((ratio) => ratio.id);
            }

            if (this.selectedLicenses && this.selectedLicenses.length > 0) {
                query.type = this.selectedLicenses;
            }

            if (this.search) {
                query.search = this.search;
            }

            query.orderBy = this.orderBy;

            return buildAdminTemplateListQueryString(query, this.meta);
        },
        handleOnPageChange(page) {
            this.meta.current_page = page;
            this.fetchTemplates();
        },
    },
    async created() {
        const data = this.data ? JSON.parse(this.data) : undefined;
        if (data && data?.category && data?.category !== "all") {
            this.selectedCategories = [data?.category];
        }
        if (data && data?.style) {
            this.selectedStyles = [data?.style];
        }
        if (data && data?.color) {
            this.selectedColors = [data?.color];
        }
        if (data && data?.aspectRatio) {
            this.selectedAspectRatios = [data?.aspectRatio];
        }
        if (data && data?.license) {
            this.selectedLicenses = [data?.license];
        }
        if (data && data?.orderBy) {
            this.orderBy = data?.orderBy;
        }
        if (data && data?.s) {
            this.search = data?.s;
        }
        await this.fetchFilterOptions();
        await this.fetchTemplates();
    },
};
</script>
